module.exports = __webpack_public_path__ + "img/icon-default.35dc8e14.png";